<div class="content-heading">
  <div class="header-container">
    <h3>Detalle de Código Postal</h3>
    <small>Gestión de información geográfica y fiscal</small>
  </div>
</div>

<div class="container-fluid">
  <div class="card card-default">
    <div class="card-body">
      <form #Form="ngForm" (ngSubmit)="formSubmit()">
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <aph-custom-text 
              label="Código Postal" 
              placeholder="Ej. 01000" 
              [(ngModel)]="zipCode.IdZipCode" 
              name="IdZipCode" 
              [required]="true" 
              [maxLength]="10" 
              [disabled]="!isNew"
              style="border:none;">
            </aph-custom-text>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-lg-6 col-md-6">
            <aph-custom-text 
              label="Código de Estado" 
              [(ngModel)]="zipCode.StateCode" 
              name="StateCode" 
              [required]="true" 
              [maxLength]="10"
              style="border:none;">
            </aph-custom-text>
          </div>
          <div class="col-lg-6 col-md-6">
            <aph-custom-text 
              label="Descripción de Estado" 
              [(ngModel)]="zipCode.StateDescription" 
              name="StateDescription" 
              [required]="true" 
              [maxLength]="100"
              style="border:none;">
            </aph-custom-text>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-lg-6 col-md-6">
            <aph-custom-text 
              label="Código de Ciudad" 
              [(ngModel)]="zipCode.CityCode" 
              name="CityCode" 
              [required]="true" 
              [maxLength]="10"
              style="border:none;">
            </aph-custom-text>
          </div>
          <div class="col-lg-6 col-md-6">
            <aph-custom-text 
              label="Descripción de Ciudad" 
              [(ngModel)]="zipCode.CityDescription" 
              name="CityDescription" 
              [required]="true" 
              [maxLength]="100"
              style="border:none;">
            </aph-custom-text>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-lg-6 col-md-6">
            <aph-custom-text 
              label="Código de Colonia" 
              [(ngModel)]="zipCode.NeighborhoodCode" 
              name="NeighborhoodCode" 
              [required]="true" 
              [maxLength]="10"
              style="border:none;">
            </aph-custom-text>
          </div>
          <div class="col-lg-6 col-md-6">
            <aph-custom-text 
              label="Descripción de Colonia" 
              [(ngModel)]="zipCode.NeighborhoodName" 
              name="NeighborhoodName" 
              [required]="true" 
              [maxLength]="100"
              style="border:none;">
            </aph-custom-text>
          </div>
        </div>

        <hr class="mt-4">

        <div class="row mt-3">
          <div class="col-12 d-flex">
            <aph-custom-buttons 
              preset="save" 
              label="Guardar" 
              type="submit" 
              [disabled]="!Form.valid"
              class="mr-2">
            </aph-custom-buttons>

            <aph-custom-buttons 
              preset="exit" 
              label="Volver" 
              (btnClick)="btnCancelOnClick()">
            </aph-custom-buttons>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>